export const UPLOAD_STATUSES = {
  CREATED: 'created',
  MAPPED: 'mapped',
  PROCESSING: 'processing',
  ZIP_UPLOAD_COMPLETE: 'zip_upload_completed',
  EXTRACTING_METADATA: 'extracting_metadata',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export const FILE_STATUSES = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
  SKIPPED: 'skipped',
  DUPLICATED: 'duplicated',
};

// auto_upload_files is an operations ledger — category rows are structural
// deletes applied synchronously at mapping time, not extracted files
export const FILE_ROW_KINDS = {
  CATEGORY: 'category',
};

export const METADATA_FIELDS = [
  { id: 'title', label: 'Title', description: 'Extract document title' },
  { id: 'subtitle', label: 'Subtitle', description: 'Extract document subtitle' },
  { id: 'keywords', label: 'Keywords', description: 'Extract relevant keywords' },
  { id: 'targetAudience', label: 'Target Audience', description: 'Identify target audience' },
  { id: 'specialty', label: 'Specialty', description: 'Medical specialty classification' },
  { id: 'subspecialty', label: 'Subspecialty', description: 'Medical subspecialty classification' },
  { id: 'contentType', label: 'Content Type', description: 'Type of content' },
];

export { isMetadataExtractableByExtension as isMetadataExtractable } from 'shared/utils/knowledge.utils';
